var Theme = Theme || {};

Theme.BackToTop = (function ($) {
    var footerClearance = 16;
    var $wrapper;
    var $button;
    var $footer;

    return {
        init: _init
    };

    function _init() {
        $wrapper = $('.js-back-to-top');
        if (!$wrapper.length) {
            return;
        }

        $button = $wrapper.find('.js-back-to-top-button');
        $footer = $('.footer_wrap');

        $(window).on('scroll', debounce(_sync, 10, false));
        $(window).on('resize', debounce(_sync, 100, false));
        $(document.body).on('focusin', _sync);
        $button.on('focusout', _onButtonFocusOut);
        $button.on('click', _scrollToTop);
        _sync();
    }

    function _sync() {
        var threshold = Math.max(600, window.innerHeight * 0.4);
        var isPastThreshold = window.pageYOffset > threshold;

        $wrapper.toggleClass('back-to-top--visible', isPastThreshold || $button.is(':focus'));
        _parkAboveFooter();
    }

    function _onButtonFocusOut() {
        if (!document.hasFocus()) {
            return;
        }

        _sync();
    }

    function _parkAboveFooter() {
        $wrapper.css('bottom', '');
        if (!$footer.length) {
            return;
        }

        var restingBottom = parseFloat(window.getComputedStyle($wrapper[0]).bottom) || 0;
        var footerIntrusion = window.innerHeight - $footer[0].getBoundingClientRect().top + footerClearance;
        var highestBottom = window.innerHeight - $button.outerHeight();

        if (footerIntrusion > restingBottom) {
            $wrapper.css('bottom', Math.min(footerIntrusion, highestBottom) + 'px');
        }
    }

    function _scrollToTop() {
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        _focusTopOfPage();
    }

    function _focusTopOfPage() {
        var skipLink = $('.skipnav')[0];

        if (skipLink) {
            skipLink.focus({ preventScroll: true });
            return;
        }

        document.body.setAttribute('tabindex', '-1');
        document.body.focus({ preventScroll: true });
    }
})(jQuery);
